import { map } from 'helpers/safeRamda';
import { theme } from 'config';

import { TransactionSummary } from './OnlineOfflineTransactions';

const legendItems = [
  {
    title: 'In-Store Transactions',
    color: theme.violet,
  },
  {
    title: 'Online Transactions',
    color: theme.deepPurple,
  },
  {
    title: 'Sales',
    color: theme.seafoamGreen,
  },
];

const salesTransformer = map(
  ({ transactionDate, totalTransactionAmount }: TransactionSummary) => ({
    x: transactionDate,
    y: totalTransactionAmount,
  }),
) as Function;

const offlineTransactionTransformer = map(
  ({
    transactionDate,
    numberOfTransactions,
    onlineNumberOfTransactions,
  }: TransactionSummary) => ({
    x: transactionDate,
    y: numberOfTransactions - onlineNumberOfTransactions,
  }),
) as Function;

const onlineTransactionTransformer = map(
  ({ transactionDate, onlineNumberOfTransactions }: TransactionSummary) => ({
    x: transactionDate,
    y: onlineNumberOfTransactions,
  }),
) as Function;

export {
  salesTransformer,
  offlineTransactionTransformer,
  onlineTransactionTransformer,
  legendItems,
};
